<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.title" v-if="isRouterAlive" />
  </div>
</template>
<script>
  export default {
    name: 'App',
    provide() {    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
      return {
        reload: this.reload
      }
    },
    data() {
      return {
        isRouterAlive: true                    //控制视图是否显示的变量
      }
    },
    methods: {
      reload() {
        this.isRouterAlive = false;            //先关闭，
        this.$nextTick(function () {
          this.isRouterAlive = true;         //再打开
        })
      }
    }
  }
</script>
<style>
  body {
    font-size: 16px;
    background-color: #fff;
    -webkit-font-smoothing: antialiased;
    font-family: Arial, Helvetica, sans-serif !important;
  }

  /* img{ width: 100%;} */
  input:-webkit-autofill,
  textarea:-webkit-autofill,
  select:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 1000px white inset;
  }

  .contentBox {
    margin-bottom: 1.33rem;
    background: #f3f6fb
  }

  .warmTip,
  .orderTip,
  .warmTips {
    font-size: 16px;
    text-align: center;
    margin-top: 55%;
  }

  .warmTip span,
  .warmTips span {
    display: block;
  }

  .warmTip img,
  .warmTips img {
    width: 40%;
    display: block;
    margin: 0 auto;
    margin-bottom: 30px;
  }
</style>
<style scoped>
  /deep/.van-nav-bar {
    height: 55px;
    line-height: 55px;
  }

  /deep/.van-nav-bar .van-icon {
    color: #000 !important;
    margin-top: -2px;
  }

  /deep/.van-nav-bar__text {
    color: #000 !important;
  }

  /deep/.van-hairline--top-bottom::after,
  /deep/.van-hairline-unset--top-bottom::after {
    border-bottom: none !important;
    border-width: 0;
  }

  /deep/.van-button {
    margin-left: 0
  }

  /deep/.van-button::before,
  /deep/.van-nav-bar__text:active {
    background: none;
  }
</style>